import React from "react"
import { HashRouter } from "react-router-dom"

import { DateTimeProvider } from "@cirrus/core/dateTime"
import { AppFormatterBuilder } from "@cirrus/core/dateTime/implementation/AppFormatter"
import { getConfig } from "@cirrus/config"
import { StylesProvider, Theme, ThemeProvider } from "@cirrus/ui-kit"

import { MainLayout, PageContent } from "./containers"
import { WithCustomerInfo } from "./providers/CustomerInfo"
import { WithLoginPageFallback } from "./providers/Fallback"
import { LoginService, LoginServiceProvider } from "./providers/LoginService"
import { WithAppNavigationService } from "./providers/NavigationService"
import { NewsProvider, NewsService } from "./providers/News"
import { WithSamlLoginBias } from "./providers/SamlLoginBias"
import { WithCustomerCssSkins } from "./providers/Skins"
import { SkinsServiceHttp } from "./providers/Skins/service"
import { TranslationsService, WithTranslations } from "./providers/Translations"
import { StartPageOutlet } from "./route/Outlet"
import { FrontendConfigProvider } from "../FrontendConfig"

const config = getConfig()

export const StartPageApp = () => (<FrontendConfigProvider config={config}>
  <HashRouter>
    <WithAppNavigationService>
      <WithCustomerInfo>
        <LoginServiceProvider service={new LoginService({ config })}>
          <WithSamlLoginBias>
            <WithTranslations service={new TranslationsService()}>
              <DateTimeProvider formatterBuilder={new AppFormatterBuilder()}>
                <ThemeProvider theme={Theme.from()}>
                  <StylesProvider>
                    <WithCustomerCssSkins service={new SkinsServiceHttp()}>
                      <WithLoginPageFallback>
                        <Page/>
                      </WithLoginPageFallback>
                    </WithCustomerCssSkins>
                  </StylesProvider>
                </ThemeProvider>
              </DateTimeProvider>
            </WithTranslations>
          </WithSamlLoginBias>
        </LoginServiceProvider>
      </WithCustomerInfo>
    </WithAppNavigationService>
  </HashRouter>
</FrontendConfigProvider>)

const Page = () => (<MainLayout>
  <NewsProvider service={new NewsService.Http(config.Customer)}>
    <PageContent>
      <StartPageOutlet/>
    </PageContent>
  </NewsProvider>
</MainLayout>)
